"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResponse = createResponse;
exports.createErrorResponse = createErrorResponse;
function createResponse(statusCode, message, data) {
    return { statusCode, message, data };
}
function createErrorResponse(statusCode, message) {
    return { statusCode, message, data: {} };
}
